module.exports = __webpack_public_path__ + "static/img/pause.40bec946.svg";